
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"2","cy":"1.889","rx":"2","ry":"1.889","fill":"#8F7A61"}}),_c('ellipse',{attrs:{"cx":"10","cy":"1.889","rx":"2","ry":"1.889","fill":"#8F7A61"}}),_c('ellipse',{attrs:{"cx":"18","cy":"1.889","rx":"2","ry":"1.889","fill":"#8F7A61"}})])
          )
        }
      }
    